import Box from "../../Box";
import CardContainer from "../../CardContainer";
import RowStats, { type Stat } from "../../RowStats";

type Props = {
	title: string;
	tooltip?: string;
	subtitle: string;
	stats: Stat[];
};
const OverallYourProgressCard = ({
	title,
	tooltip,
	subtitle,
	stats,
}: Props) => {
	return (
		<CardContainer
			title={title}
			tooltip={tooltip}
			subtitle={subtitle}
			icon="chart-timeline-variant-shimmer"
		>
			<Box padding={16} gap={24}>
				<RowStats stats={stats} itemWidth="15%" />
			</Box>
			{/* <AiInsightsSuggestion
				text={insights}
				buttonProps={{
					cta: "Learn more",
					onPress: () => {
						handleClickLearnMore?.("overall");
					},
				}}
			/> */}
		</CardContainer>
	);
};

export default OverallYourProgressCard;
